import { AutoScrollContainer } from '~/screens/PageBuilder/blocks/BrandExperience/AutoScrollContainer';
import { BrandItemComponent } from '~/screens/PageBuilder/blocks/BrandExperience/BrandItemComponent';
import { Carousel } from '~/screens/PageBuilder/blocks/BrandExperience/Carousel';

export type BrandItem = {
  src: string;
  alt: string;
};

export interface BrandExperienceProperties {
  brandItems: BrandItem[];
}

export type BrandExperienceProps = {
  items: BrandItem[];
  isShared?: boolean;
};

// Helper component to render brand items consistently
const BrandItemsList = ({
  items,
}: {
  items: BrandItem[];
  className?: string;
}) => (
  <>
    {items.map((item, idx) => (
      <BrandItemComponent key={`${item.alt}-${idx}`} item={item} idx={idx} />
    ))}
  </>
);

export const BrandExperience = ({
  items,
  isShared = false,
}: BrandExperienceProps) => {
  // Shared mode - use auto-scroll for many items, static for few
  if (isShared) {
    return (
      <section aria-label="Brand experience">
        <AutoScrollContainer items={items} />
      </section>
    );
  }

  // Edit mode - use carousel for many items with responsive behavior
  return (
    <section
      aria-label="Brand experience"
      className="mx-auto w-full max-w-[1050px] px-4"
    >
      <div className="flex justify-center">
        <div className="hidden w-full max-w-full mac:block">
          <Carousel
            className="w-full"
            leftNavigationClassName="-ml-12"
            rightNavigationClassName="-mr-12"
          >
            <BrandItemsList items={items} />
          </Carousel>
        </div>
      </div>
    </section>
  );
};
